// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACySURBVHgB7ZNNCsIwEIXfmIKIWLPpz7Jbi3dTT9B6Er2CN/AIXbnxBNKFFRR0EWMSKFgVMcnWbzUzi4/3CAG+ECbT2TjJj5xnHK6EcV4oieTpZA1X/pIO1EqIUKqxEuK+sBEEJJqm3ldGpJPAg9NhR4GJRVhKiQKQFZG0SgTRazo7T/NSJ1M1V3CAtcP1XG8Ho0hXnfeHUXa71BtYwJ4XHxl7PbjK2Kejb803zAPEv/3+BxZ4TlFctqAQAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MovementSidePanel_overlay__7Kds3 {
  text-align: left;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: flex-end;
  z-index: 2000;
}

.MovementSidePanel_panel__6VEfx {
 padding: 32px;
  width: 85%;
  background: rgba(249, 249, 249, 1);
  display: flex;
  flex-direction: column;
  animation: MovementSidePanel_slideIn__e4Dmk 0.3s ease-out;

}

.MovementSidePanel_header__iXyOw {
    padding: 20.5px;
    background-color: white;
    border-radius: 8px;
}

.MovementSidePanel_backButton__CIlDx {
    display: flex;
    align-items: center;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-position: center left;
    background-repeat: no-repeat;
    background-size: 16px;
    border: none;
    font-size: 16px;
    cursor: pointer;
}

.MovementSidePanel_backText__owb2y {
    font-weight: bold;
    font-size: 18px;
    padding-left: 20px;
}


.MovementSidePanel_searchWrapper__oVnMr {
  margin-top: 20px;
  position: relative;
  width: 100%; /* можно ограничить фикс шириной, если нужно */
}

.MovementSidePanel_search__26rjC {
  border-radius: 8px;
  background-color: white;
  padding: 20.5px;
  display: flex;
  gap: 20px;
  align-items: center;
  margin-bottom: 0; /* убрать, так как список будет прилегать */
}

.MovementSidePanel_results__mbtz- {
  position: absolute;
  top: 100%; /* сразу под поиском */
  left: 0;
  width: 100%; /* ширина совпадает с searchWrapper */
  background: #fff;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10;
  border-radius: 8px;
  margin-top: 5px;
}


.MovementSidePanel_input__EhzQX {
  flex: 1 1;
  padding: 10px 15px;
  font-size: 16px;
  border-radius: 8px;
  background: white;
  border: 1px solid #ccc;
}

.MovementSidePanel_addButton__NBAHF {
  padding: 8px 12px;
  background: rgba(29, 135, 82, 1);
  border: none;
  border-radius: 6px;
  color: white;
  cursor: pointer;
}

.MovementSidePanel_list__9BtYW {
  list-style: none;
  padding: 0;
  margin: 0;
}

.MovementSidePanel_item__4ahzW {
  padding: 10px;
  border-bottom: 1px solid #eee;
}

.MovementSidePanel_item__4ahzW:hover {
    background: rgb(189, 189, 189);
    color: white;
}

.MovementSidePanel_item__4ahzW:hover .MovementSidePanel_itemQty__cFM04 {
    color: white;
}

.MovementSidePanel_itemName__E5bY7 {
  font-weight: 500;
}

.MovementSidePanel_itemQty__cFM04 {
  font-size: 14px;
  color: #666;
}

.MovementSidePanel_noResults__nUPoI, .MovementSidePanel_loading__GWx7O {
  color: #888;
  text-align: center;
  margin-top: 20px;
}
.MovementSidePanel_table__Q\\+orx {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
  background: white;
  border-radius: 10px;
  overflow: hidden;
}

.MovementSidePanel_table__Q\\+orx th, .MovementSidePanel_table__Q\\+orx td {
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid #ddd;
}

.MovementSidePanel_table__Q\\+orx th {
  background: #f5f5f5;
  font-weight: bold;
}

.MovementSidePanel_copyIcon__kYIOg {
  margin-right: 8px;
  cursor: pointer;
  color: rgba(29, 135, 82, 1);
  transition: 0.2s;
}
.MovementSidePanel_copyIcon__kYIOg:hover {
  color: rgb(22, 102, 62);
}

.MovementSidePanel_qtyBtn__QvC2T {
  background: rgba(29, 135, 82, 1);
  color: white;
  border: none;
  padding: 5px 10px;
  margin: 0 5px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}
.MovementSidePanel_qtyBtn__QvC2T:hover {
  background: rgb(22, 102, 62);
}

.MovementSidePanel_qty__5DgcB {
  font-weight: bold;
  font-size: 16px;
  margin: 0 5px;
}

.MovementSidePanel_deleteBtn__7CqsA {
  background: #dc3545;
  color: white;
  border: none;
  padding: 6px 12px;
  border-radius: 5px;
  cursor: pointer;
  transition: 0.2s;
}
.MovementSidePanel_deleteBtn__7CqsA:hover {
  background: #a71d2a;
}
.MovementSidePanel_footer__1az3H {
  width: 85%;
  position: absolute;
  bottom: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px 48px 32px;
  border-top: 1px solid #eee;
  background: #fff;
}

.MovementSidePanel_footerLeft__kRdJa {
  background: rgba(249, 249, 249, 1);
  border: 1px solid rgba(242, 242, 242, 1);
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 20px;
  border-radius: 8px;
  font-size: 14px;
}

.MovementSidePanel_editBtn__KhCf3 {
  font-size: 18px;
  border-radius: 6px;
  padding: 4px 6px;
  cursor: pointer;
}

.MovementSidePanel_footerRight__6YTpY {
  display: flex;
  align-items: center;
  gap: 8px;
}

.MovementSidePanel_select__5xtMK, .MovementSidePanel_comment__ByF6R {
  padding:  16px 18px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

.MovementSidePanel_comment__ByF6R {
  min-width: 200px;
}

.MovementSidePanel_finishBtn__fl0sJ {
  background: #178a44;
  color: white;
  border: none;
  padding: 16px 18px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
}

.MovementSidePanel_finishBtn__fl0sJ:hover {
  background: #0f6d35;
}

.MovementSidePanel_from__-3CvL, .MovementSidePanel_to__Om-N6 {
  font-size: 14px;
}

@keyframes MovementSidePanel_slideIn__e4Dmk {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/tables/customComponentsTable/MovementSidePanel.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;EACb,yBAAyB;EACzB,aAAa;AACf;;AAEA;CACC,aAAa;EACZ,UAAU;EACV,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,yDAAgC;;AAElC;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yDAAya;IACza,gCAAgC;IAChC,4BAA4B;IAC5B,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW,EAAE,8CAA8C;AAC7D;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB,EAAE,2CAA2C;AAC/D;;AAEA;EACE,kBAAkB;EAClB,SAAS,EAAE,sBAAsB;EACjC,OAAO;EACP,WAAW,EAAE,qCAAqC;EAClD,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;;AAGA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;AACA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,4BAA4B;EAC5B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".overlay {\n  text-align: left;\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  justify-content: flex-end;\n  z-index: 2000;\n}\n\n.panel {\n padding: 32px;\n  width: 85%;\n  background: rgba(249, 249, 249, 1);\n  display: flex;\n  flex-direction: column;\n  animation: slideIn 0.3s ease-out;\n\n}\n\n.header {\n    padding: 20.5px;\n    background-color: white;\n    border-radius: 8px;\n}\n\n.backButton {\n    display: flex;\n    align-items: center;\n    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACySURBVHgB7ZNNCsIwEIXfmIKIWLPpz7Jbi3dTT9B6Er2CN/AIXbnxBNKFFRR0EWMSKFgVMcnWbzUzi4/3CAG+ECbT2TjJj5xnHK6EcV4oieTpZA1X/pIO1EqIUKqxEuK+sBEEJJqm3ldGpJPAg9NhR4GJRVhKiQKQFZG0SgTRazo7T/NSJ1M1V3CAtcP1XG8Ho0hXnfeHUXa71BtYwJ4XHxl7PbjK2Kejb803zAPEv/3+BxZ4TlFctqAQAAAAAElFTkSuQmCC);\n    background-position: center left;\n    background-repeat: no-repeat;\n    background-size: 16px;\n    border: none;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.backText {\n    font-weight: bold;\n    font-size: 18px;\n    padding-left: 20px;\n}\n\n\n.searchWrapper {\n  margin-top: 20px;\n  position: relative;\n  width: 100%; /* можно ограничить фикс шириной, если нужно */\n}\n\n.search {\n  border-radius: 8px;\n  background-color: white;\n  padding: 20.5px;\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  margin-bottom: 0; /* убрать, так как список будет прилегать */\n}\n\n.results {\n  position: absolute;\n  top: 100%; /* сразу под поиском */\n  left: 0;\n  width: 100%; /* ширина совпадает с searchWrapper */\n  background: #fff;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10;\n  border-radius: 8px;\n  margin-top: 5px;\n}\n\n\n.input {\n  flex: 1;\n  padding: 10px 15px;\n  font-size: 16px;\n  border-radius: 8px;\n  background: white;\n  border: 1px solid #ccc;\n}\n\n.addButton {\n  padding: 8px 12px;\n  background: rgba(29, 135, 82, 1);\n  border: none;\n  border-radius: 6px;\n  color: white;\n  cursor: pointer;\n}\n\n.list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n}\n\n.item {\n  padding: 10px;\n  border-bottom: 1px solid #eee;\n}\n\n.item:hover {\n    background: rgb(189, 189, 189);\n    color: white;\n}\n\n.item:hover .itemQty {\n    color: white;\n}\n\n.itemName {\n  font-weight: 500;\n}\n\n.itemQty {\n  font-size: 14px;\n  color: #666;\n}\n\n.noResults, .loading {\n  color: #888;\n  text-align: center;\n  margin-top: 20px;\n}\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n  background: white;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.table th, .table td {\n  padding: 10px;\n  text-align: center;\n  border-bottom: 1px solid #ddd;\n}\n\n.table th {\n  background: #f5f5f5;\n  font-weight: bold;\n}\n\n.copyIcon {\n  margin-right: 8px;\n  cursor: pointer;\n  color: rgba(29, 135, 82, 1);\n  transition: 0.2s;\n}\n.copyIcon:hover {\n  color: rgb(22, 102, 62);\n}\n\n.qtyBtn {\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  margin: 0 5px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n}\n.qtyBtn:hover {\n  background: rgb(22, 102, 62);\n}\n\n.qty {\n  font-weight: bold;\n  font-size: 16px;\n  margin: 0 5px;\n}\n\n.deleteBtn {\n  background: #dc3545;\n  color: white;\n  border: none;\n  padding: 6px 12px;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: 0.2s;\n}\n.deleteBtn:hover {\n  background: #a71d2a;\n}\n.footer {\n  width: 85%;\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 32px 48px 32px;\n  border-top: 1px solid #eee;\n  background: #fff;\n}\n\n.footerLeft {\n  background: rgba(249, 249, 249, 1);\n  border: 1px solid rgba(242, 242, 242, 1);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 20px;\n  border-radius: 8px;\n  font-size: 14px;\n}\n\n.editBtn {\n  font-size: 18px;\n  border-radius: 6px;\n  padding: 4px 6px;\n  cursor: pointer;\n}\n\n.footerRight {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.select, .comment {\n  padding:  16px 18px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n}\n\n.comment {\n  min-width: 200px;\n}\n\n.finishBtn {\n  background: #178a44;\n  color: white;\n  border: none;\n  padding: 16px 18px;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.finishBtn:hover {\n  background: #0f6d35;\n}\n\n.from, .to {\n  font-size: 14px;\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `MovementSidePanel_overlay__7Kds3`,
	"panel": `MovementSidePanel_panel__6VEfx`,
	"slideIn": `MovementSidePanel_slideIn__e4Dmk`,
	"header": `MovementSidePanel_header__iXyOw`,
	"backButton": `MovementSidePanel_backButton__CIlDx`,
	"backText": `MovementSidePanel_backText__owb2y`,
	"searchWrapper": `MovementSidePanel_searchWrapper__oVnMr`,
	"search": `MovementSidePanel_search__26rjC`,
	"results": `MovementSidePanel_results__mbtz-`,
	"input": `MovementSidePanel_input__EhzQX`,
	"addButton": `MovementSidePanel_addButton__NBAHF`,
	"list": `MovementSidePanel_list__9BtYW`,
	"item": `MovementSidePanel_item__4ahzW`,
	"itemQty": `MovementSidePanel_itemQty__cFM04`,
	"itemName": `MovementSidePanel_itemName__E5bY7`,
	"noResults": `MovementSidePanel_noResults__nUPoI`,
	"loading": `MovementSidePanel_loading__GWx7O`,
	"table": `MovementSidePanel_table__Q+orx`,
	"copyIcon": `MovementSidePanel_copyIcon__kYIOg`,
	"qtyBtn": `MovementSidePanel_qtyBtn__QvC2T`,
	"qty": `MovementSidePanel_qty__5DgcB`,
	"deleteBtn": `MovementSidePanel_deleteBtn__7CqsA`,
	"footer": `MovementSidePanel_footer__1az3H`,
	"footerLeft": `MovementSidePanel_footerLeft__kRdJa`,
	"editBtn": `MovementSidePanel_editBtn__KhCf3`,
	"footerRight": `MovementSidePanel_footerRight__6YTpY`,
	"select": `MovementSidePanel_select__5xtMK`,
	"comment": `MovementSidePanel_comment__ByF6R`,
	"finishBtn": `MovementSidePanel_finishBtn__fl0sJ`,
	"from": `MovementSidePanel_from__-3CvL`,
	"to": `MovementSidePanel_to__Om-N6`
};
export default ___CSS_LOADER_EXPORT___;
